import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	animate,
	state,
	style,
	transition,
	trigger,
} from '@angular/animations';
import {
	MatSidenavContainer,
	MatSidenav,
	MatSidenavContent,
} from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
	selector: 'app-reports',
	templateUrl: './reports.component.html',
	styleUrls: ['./reports.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [
		trigger('sideNavMenuAnimationState', [
			state(
				'topX',
				style({
					transform: 'rotate(45deg)',
					transformOrigin: 'left',
					margin: '7px',
				})
			),
			state(
				'hide',
				style({
					opacity: 0,
				})
			),
			state(
				'bottomX',
				style({
					transform: 'rotate(-45deg)',
					transformOrigin: 'left',
					margin: '7px',
				})
			),
			state('line', style({})),
			transition(':enter', []),
			transition('* => *', [animate('0.2s')]),
		]),
	],
	imports: [
		MatSidenavContainer,
		MatSidenav,
		MatNavList,
		MatListItem,
		RouterLink,
		RouterLinkActive,
		MatSidenavContent,
		NgClass,
		RouterOutlet,
	],
})
export class ReportsComponent implements OnInit {
	isSideNavMenuOpen = false;
	constructor() {}

	ngOnInit(): void {}

	toggleSideNav() {
		this.isSideNavMenuOpen = !this.isSideNavMenuOpen;
	}
}
